import {
  css,
  Input,
  InputAdornment,
  Stack,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useContext, useEffect } from 'react'
import LocationIcon from 'assets/icons/nucleo/18px_location.svg'
import Xmark from 'assets/icons/nucleo/18px_xmark.svg'
import { Type } from 'components/event/RaceCard/RaceCard.style'
import { unifiedColors } from 'styles/colors'
import { Theme, themeUtils } from 'styles/theme'
import { Buttons } from './Buttons'
import { LocationAutocomplete } from './LocationAutocomplete'
import { LocationTabContainer } from './LocationTabContent.style'
import { SearchBarContext } from './SearchBarContext'

export type Option = {
  id: string
  name: string
  'admin2 code'?: string
  'feature code'?: string
  bbox?: {
    southWest: [number, number]
    northEast: [number, number]
  }
  _highlightResult?: {
    id: { value: string }
    name: { value: string }
  }
  _geo: {
    lat: number
    lng: number
  }
}

interface TypeTabContentProps {
  apply?: () => void
}

export const LocationTabContent = ({ apply }: TypeTabContentProps) => {
  const theme: Theme = useTheme()
  const isMobile = useMediaQuery(themeUtils.maxWidth.md)
  const { t } = useTranslation('home')
  const {
    locationSearch,
    setLocationSearch,
    setLocation,
    location,
    locationAutocomplete
  } = useContext(SearchBarContext)

  useEffect(() => {
    locationAutocomplete.setIsOpen(true)
  }, [])

  return (
    <>
      {isMobile && (
        <Stack padding="0 8px" gap="8px">
          <Input
            sx={{
              '&:after, &:before': {
                content: 'unset'
              }
            }}
            startAdornment={
              <InputAdornment position="start">
                <LocationIcon />
              </InputAdornment>
            }
            slotProps={{
              input: {
                sx: {
                  ...theme.typography.body2
                }
              }
            }}
            placeholder={t('head.findRaceLocation')}
            css={css`
              background-color: ${unifiedColors.surface.default};
              padding: 20px 16px;
              border-radius: 16px;
            `}
            value={locationSearch}
            onChange={(e) => {
              setLocationSearch(e.target.value)
              locationAutocomplete.setQuery(e.target.value)
              locationAutocomplete.refresh()
            }}
          />
          {location && (
            <Stack flexDirection="row">
              <Type
                $backgroundColor="pink"
                $color="default"
                css={css`
                  padding: 4px 8px;
                  gap: 8px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                `}
              >
                {location.name}
                <Xmark
                  css={css`
                    min-width: 18px;
                    cursor: pointer;
                  `}
                  onClick={() => setLocation(null)}
                />
              </Type>
            </Stack>
          )}
        </Stack>
      )}
      <LocationTabContainer>
        <LocationAutocomplete />
        {!isMobile && <Buttons apply={apply} clear={() => setLocation(null)} />}
      </LocationTabContainer>
    </>
  )
}
